export default "__VITE_ASSET__3798ca21__"